import type { GetBillingOverviewResponseDto } from '../../../api/generated/model/getBillingOverviewResponseDto';

export type TopUpPack = NonNullable<GetBillingOverviewResponseDto['topUp']>['packs'][number];

/** The pack to preselect: the one auto-recharge buys (the last top-up), else the first. */
export const defaultPackId = (packs: TopUpPack[], preferred: string | null | undefined): string =>
  packs.find((pack) => pack.priceId === preferred)?.priceId ?? packs[0]?.priceId ?? '';
